import React, {useState, useEffect} from 'react';
import { BiSolidQuoteAltRight } from "react-icons/bi";
import logo from '../../assets/Images/logo rev.png';
import bannerVector from '../../assets/Images/bg ( features).png'
import { BiSolidQuoteAltLeft } from "react-icons/bi";
import maskphoto2 from '../../assets/Images/Mask group.png'
import curve from '../../assets/Images/Rectangle 3772.png';
import axios from 'axios';
import Swal from 'sweetalert2';
import { BiRightArrowAlt } from "react-icons/bi";
 import Feature from '../../assets/Images/pricing.png';
import './Pricing.css'
import { useLocation, useNavigate } from 'react-router-dom';
import { FaCircleCheck } from "react-icons/fa6";
import robopink from '../../assets/Images/hugeicons_robotic.png';
import robowhite from '../../assets/Images/1st card.png'
import streamlinepink from '../../assets/Images/streamline_user-profile-focus-solid.png';
import streamlinewhite from '../../assets/Images/2nd card.png'
import integrationpink from '../../assets/Images/oui_integration-general.png';
import integrationwhite from '../../assets/Images/3rd card.png';
import carbonpink from '../../assets/Images/carbon_analytics.png';
import carbonwhite from '../../assets/Images/4th card.png';
import campaignpink from '../../assets/Images/Black.png';
import campaignwhite from '../../assets/Images/5th card.png';
import successpink from '../../assets/Images/Black (1).png';
import successwhite from '../../assets/Images/6th card.png';
import { IoMdClose } from "react-icons/io";
import { IoIosClose } from "react-icons/io";
import { RiArrowDropDownLine } from "react-icons/ri";
import {  Switch } from '@mui/material';
import { styled } from '@mui/material/styles';


function Pricing() {

  const baseURL =
    process.env.NODE_ENV === 'production'
      ? process.env.REACT_APP_API_URL_PROD
      : process.env.REACT_APP_API_URL_LOCAL;

  const [fullName, setFullName] = useState('');
  const [organization, setOrganization] = useState('');
    const [email, setEmail] = useState('');
    const [country, setCountry] = useState('');
    const [title, setTitle] = useState('');
   const navigate = useNavigate("");
     const [active, setActive] = useState("monthly");
     const [showpopup, setShowPopup] = useState(false);
                     const [isExpanded, setIsExpanded] = useState(false);
                      const [isOpen, setIsOpen] = useState(false);
                       const [isOpen2, setIsOpen2] = useState(false);
                       const [showBanner, setShowBanner] = useState(false);
                       const [nonNecessaryEnabled, setNonNecessaryEnabled] = useState(true);

                        
                             useEffect(() => {
                                const consent = localStorage.getItem("cookieConsent");
                                if (!consent) {
                                  setShowBanner(true); // show banner for first-time users
                                } else {
                                  const parsedConsent = JSON.parse(consent);
                                  setNonNecessaryEnabled(parsedConsent.nonNecessaryEnabled);
                                  if (!parsedConsent.nonNecessaryEnabled) {
                                    setShowBanner(true); // show banner if user disabled cookies
                                  } else {
                                    setShowBanner(false);
                                  }
                                }
                              }, []);
                              
                              const handleAccept = () => {
                                localStorage.setItem(
                                  "cookieConsent",
                                  JSON.stringify({ nonNecessaryEnabled: true })
                                );
                                setNonNecessaryEnabled(true);
                                setShowBanner(false);
                              };
                              
                              const handleSaveExit = () => {
                                localStorage.setItem(
                                  "cookieConsent",
                                  JSON.stringify({ nonNecessaryEnabled })
                                );
                              
                                if (nonNecessaryEnabled) {
                                  setShowBanner(false); // hide if enabled
                                } else {
                                  setShowBanner(true); // show if disabled
                                }
                                setShowPopup(false);
                              };
                               const content = `This website uses cookies to improve your experience while
                               you navigate through the website. Out of these cookies, the cookies that are categorized as necessary 
                               are stored on your browser as they are as essential for the working of basic functionalities of the 
                               website. We also use third-party cookies that help us analyze and understand how you use this website.
                                These cookies will be stored in your browser only with your consent. You also have the option to
                                 opt-out of these cookies. But opting out of some of these cookies may have an effect on your browsing
                                  experience.`;
                            
                                  const toggleReadMore = () => {
                                setIsExpanded(!isExpanded);
                              };
                              const toggleContent = () => {
                                setIsOpen2(false);
                                setIsOpen(!isOpen);
                                
                              }
                            
                              const toggleContent2 = () => {
                                setIsOpen(false)
                                setIsOpen2(!isOpen2)
                                
                              }
                            
                              const handleClose = () => {
                                setShowPopup(false);
                              }
                            
                              const CustomSwitch = styled((props) => <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />)(
                                ({ theme }) => ({
                                  width: 60,
                                  height: 25,
                                  padding: 0,
                                  display: 'flex',
                                  marginLeft:10,
                                  '& .MuiSwitch-switchBase': {
                                    padding: 4,
                                    '&.Mui-checked': {
                                      transform: 'translateX(26px)',
                                      color: '#009F0B',
                                      '& + .MuiSwitch-track': {
                                        backgroundColor: '#009F0B',
                                        '&:before': {
                                          left: 8,
                                        },
                                      },
                                    },
                                  },
                                  '& .MuiSwitch-thumb': {
                                    boxShadow: '0 2px 4px 0 rgb(0 0 0 / 20%)',
                                    width: 19,
                                    height: 19,
                                    borderRadius: '50%',
                                    backgroundColor: '#D9D9D9',
                                    marginLeft:5,
                                  },
                                  '& .MuiSwitch-track': {
                                    position: 'relative',
                                    borderRadius: 34 / 2,
                                    backgroundColor: 'grey',
                                    transition: theme.transitions.create(['background-color'], {
                                      duration: 500,
                                    }),
                                    '&:before': {
                                      position: 'absolute',
                                      top: '50%',
                                      transform: 'translateY(-50%)',
                                      left: 34,
                                      color: 'white',
                                      fontSize: 12,
                                      fontWeight: 600,
                                    },
                                  },
                                })
                              );
                            
                              const cookiePopup = () => {
                                setShowPopup(true);
                              }
                            
                         


   const handlePricingClick = async () => {
    if (!email) {
      alert("Please enter a valid email address");
      return;
    }

    try {
      await axios.post('http://localhost:5000/api/send-mail', { email });
      Swal.fire({
      icon: "success",
      title: "Success",
      text: "Email sent successfully!",
    });
    } catch (error) {
      console.error("Error sending email:", error);
      Swal.fire({
      icon: "error",
      title: "Oops!",
      text: "Failed to send email. Please try again later.",
    });
    }
  };
  
    const [abmReports, setAbmReports] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
  const [question, setQuestion] = useState("");
  const [message, setMessage] = useState('')
    const location = useLocation();
    const [menuOpen, setMenuOpen] = useState(false);

    const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };
  
  
  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!fullName || !organization || !title || !email || !country || !abmReports  || !question) {
        setErrorMessage('All fields are required');
        return;
    }

    try {
        const response = await fetch(`${baseURL}/api/send-email`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ fullName, organization, email, title, country, abmReports, question, }),
        });

        const data = await response.json();

        if (response.ok && data.success) {
            setMessage(
            <span style={{color: 'green' , textAlign:"center"}}>Email sent successfully!</span>
        );
            setErrorMessage(''); 
            setFullName('');
            setOrganization('');
            setTitle('');
            setEmail('');
            setCountry('');
            setAbmReports('');
           
            setQuestion('');
        } else {
            setErrorMessage(data.message || 'Failed to send email');
        }
    } catch (error) {
        console.error('Error:', error);
        setErrorMessage('An error occurred. Please try again.');
    }
};

  


  return (
    <>
    <div>
               <img src={bannerVector} alt="vector background" className='banner-vector2' />
            </div>
            <div>
        <div className="header">
          <div className="container">
            <div className="header-logo">
              <img
                src={logo}
                alt="octonius-logo"
                onClick={() => navigate("/")}
                style={{ cursor: "pointer" }}
              />
            </div>
        
            {/* Hamburger button */}
            <button className="hamburger" onClick={toggleMenu}>☰</button>
        
            {/* Nav Menu */}
            <div className={`nav-menu ${menuOpen ? "open" : ""}`}>
              {/* Close button inside nav */}
              <button className="close-btn" onClick={toggleMenu}><IoMdClose /></button>
        
              <nav className={`menu ${location.pathname === "/" ? "active" : ""}`} onClick={() => navigate("/")}>
                Home
              </nav>
              <nav className={`menu ${location.pathname === "/features" ? "active" : ""}`} onClick={() => navigate("/features")}>
                Features
              </nav>
              <nav className={`menu ${location.pathname === "/pricing" ? "active" : ""}`} onClick={() => navigate("/pricing")}>
                Pricing
              </nav>
              <nav className={`menu ${location.pathname === "/contact" ? "active" : ""}`} onClick={() => navigate("/contact")}>
                Contact
              </nav>
        
              <div className="free-login">
              <nav className="menu" onClick={() => window.open("https://app.revenuintel.com", "_blank")}>
  Login
</nav>

                
                <button className="log-btn" onClick={() => navigate('/free-trial')}>
                  Free Trial <span className="btn-icon"><BiRightArrowAlt /></span>
                </button>
              </div>
            </div>
          </div>
        </div>
           </div>
           <div className='landing-page'>
           
           <div className='banner-content2'>
                <div className='land-title'>
                    <div className='price-title1'>Choose the right plan for you </div>
                     <div className='subscriptions-btns'>
            <div
          className={`sub-btn ${active === "monthly" ? "active" : ""}`}
          onClick={() => setActive("monthly")}
        >
          Pay Monthly
        </div>
        <div
          className={`sub-btn ${active === "yearly" ? "active" : ""}`}
          onClick={() => setActive("yearly")}
        >
          Pay Yearly(Save 23%)
        </div>
           </div>
                    {/* <div className='land-title2'>Built for One Mission </div>
                     <div className='land-title2' style={{fontSize:"32px", color:"#E31A5F"}}>"Book More Qualified Meetings” </div>
                    <div className='land-title4' style={{fontWeight:"400", marginTop:"0", fontSize:"15px"}}> Combine human-verified prospect data with AI-driven engagement agents to transform your pipeline from guesswork into a predictable, revenue-generating engine </div>
                   */}
                </div>
                </div>
           
          
           <div className='price-plans'>
             <div className='price-plan-container-bg1'></div>
             <div className='price-plan-container-bg2'></div>
            <div className='price-plan-containers'>
             <div className='price-plan-container1'>
              <div className='price-include'>What's Includes</div>
              <div className='price-plan-list'>
                <div className='price-plan-list-icon'> <FaCircleCheck /></div>
                <div className='price-plan-list-text'>Unlimited Contacts</div>
              </div>
               <div className='price-plan-list'>
                <div className='price-plan-list-icon'> <FaCircleCheck /></div>
                <div className='price-plan-list-text'>Unlimited Emails</div>
              </div>
               <div className='price-plan-list'>
                <div className='price-plan-list-icon'> <FaCircleCheck /></div>
                <div className='price-plan-list-text'>1,200 monthly credits (expandable with add-ons)</div>
              </div>
               <div className='price-plan-list'>
                <div className='price-plan-list-icon'> <FaCircleCheck /></div>
                <div className='price-plan-list-text'>Credits usable for contacts, scoops, AI tasks</div>
              </div>
             
             </div>
             <div className='price-plan-container2'>
              <div className='price-standard'>Standard</div>
              {active === "yearly" && (
    <div className="save-badge">Save<br />23%</div>
  )}

  {/* Price */}
  <div className='price-plan-amnt'>
    {active === "monthly" ? "$189/Per Month" : "$149/Per Month"}
  </div>
  {active === "yearly" && (
    <div className="billed-info">Billed Annually</div>
  )}
              <div className='price-plan-con'>“Best value for growing teams”</div>
              <button className='price-plan-btn' onClick={() => {navigate("/free-trial"); window.scrollTo(0, 0); }}>Start Free Trial</button>
             </div>
                 <div className='price-plan-container3'>
                  <div className='price-enterprise'>EnterPrise</div>
                  <div className='price-plan-ques'>Let's Talk</div>
                  <div className='price-plan-list2'>
                <div className='price-plan-list-icon'> <FaCircleCheck /></div>
                <div className='price-plan-list-text'>Custom AI Agents</div>
              </div>
              <div className='price-plan-list2'>
                <div className='price-plan-list-icon'> <FaCircleCheck /></div>
                <div className='price-plan-list-text'>Dedicated Sucess Coach</div>
              </div>
              <div className='price-plan-list2'>
                <div className='price-plan-list-icon'> <FaCircleCheck /></div>
                <div className='price-plan-list-text'>Enhanced Security & SLA</div>
              </div>
                 </div>
               </div>
           </div>
            <div className='pricing-plan-plat'>
             Platform Features
           </div>
           <div className='pricing-plan-features'>
            <div className='price-feature-container1'>
            <div className='price-feature-img1'>
    <img src={robowhite} alt="robo white" className="robo robo-white" />
    <img src={robopink} alt="robo pink" className="robo robo-pink" />
  </div>
              <div className='price-plan-agent'>AI Agents</div>
               <div className='price-plan-features-list'>
                <div className='price-plan-features-icon'> <FaCircleCheck /></div>
                <div className='price-plan-features-text'>AI research agent for account Insights</div>
              </div>
               <div className='price-plan-features-list'>
                <div className='price-plan-features-icon'> <FaCircleCheck /></div>
                <div className='price-plan-features-text'>Outreach Personalization & Messaging Agent
</div>
              </div>
               <div className='price-plan-features-list'>
                <div className='price-plan-features-icon'> <FaCircleCheck /></div>
                <div className='price-plan-features-text'>AI Data Enrichment & Cleansing Agent</div>
              </div>
               <div className='price-plan-features-list'>
                <div className='price-plan-features-icon'> <FaCircleCheck /></div>
                <div className='price-plan-features-text'>AI Competitor Intelligence Agent</div>
              </div>
               <div className='price-plan-features-list'>
                <div className='price-plan-features-icon'> <FaCircleCheck /></div>
                <div className='price-plan-features-text'>AI Assistant for ICP & Buyer Fit Matching
</div>
              </div>
               <div className='price-plan-features-list'>
                <div className='price-plan-features-icon'> <FaCircleCheck /></div>
                <div className='price-plan-features-text'>Unified CRM Email Agent</div>
              </div>
               <div className='price-plan-features-list'>
                <div className='price-plan-features-icon'> <FaCircleCheck /></div>
                <div className='price-plan-features-text'>Predictive Pipeline Growth Agent
</div>
              </div>
            </div>
             <div className='price-feature-container2'>
              <div className='price-feature-img2'>
    <img src={streamlinepink} alt="robo white" className="streamline stream-pink" />
    <img src={streamlinewhite} alt="robo pink" className="streamline stream-white" />
  </div>
              <div className='price-plan-agent'>Contacts & Data Intelligence</div>
               <div className='price-plan-features-list'>
                <div className='price-plan-features-icon'> <FaCircleCheck /></div>
                <div className='price-plan-features-text'>Human Verified People & Company Search
</div>
              </div>
               <div className='price-plan-features-list'>
                <div className='price-plan-features-icon'> <FaCircleCheck /></div>
                <div className='price-plan-features-text'>Contacts & Data Intelligence</div>
              </div>
               <div className='price-plan-features-list'>
                <div className='price-plan-features-icon'> <FaCircleCheck /></div>
                <div className='price-plan-features-text'>Scoops / Sales Intelligence Signal</div>
              </div>
               <div className='price-plan-features-list'>
                <div className='price-plan-features-icon'> <FaCircleCheck /></div>
                <div className='price-plan-features-text'>AI Research Agent for Account Insights
</div>
              </div>
              <div className='price-plan-features-list'>
                <div className='price-plan-features-icon'> <FaCircleCheck /></div>
                <div className='price-plan-features-text'>Intent & ICP Matching
</div>
              </div>
            </div>
             <div className='price-feature-container3'>
              <div className='price-feature-img3'>
    <img src={integrationpink} alt=" white" className="integration inte-pink" />
    <img src={integrationwhite} alt="robo pink" className="integration inte-white" />
  </div>
              <div className='price-plan-agent'>Operations & Integration</div>
               <div className='price-plan-features-list'>
                <div className='price-plan-features-icon'> <FaCircleCheck /></div>
                <div className='price-plan-features-text'>Gmail & Outlook Integration</div>
              </div>
               <div className='price-plan-features-list'>
                <div className='price-plan-features-icon'> <FaCircleCheck /></div>
                <div className='price-plan-features-text'>Native CRM Sync ( two - way )</div>
              </div>
               <div className='price-plan-features-list'>
                <div className='price-plan-features-icon'> <FaCircleCheck /></div>
                <div className='price-plan-features-text'>Single Sign - On ( SSO )</div>
              </div>
               <div className='price-plan-features-list'>
                <div className='price-plan-features-icon'> <FaCircleCheck /></div>
                <div className='price-plan-features-text'>Advanced Security Configuration</div>
              </div>
            </div>
           </div>
            <div className='pricing-plan-features'>
            <div className='price-feature-container1' style={{height:"500px"}}>
            <div className='price-feature-img1'>
    <img src={carbonwhite} alt="robo white" className="robo robo-white" />
    <img src={carbonpink} alt="robo pink" className="robo robo-pink" />
  </div>
              <div className='price-plan-agent'>Analytics & Reporting</div>
               <div className='price-plan-features-list'>
                <div className='price-plan-features-icon'> <FaCircleCheck /></div>
                <div className='price-plan-features-text'>Standard Campaign Reporting</div>
              </div>
               <div className='price-plan-features-list'>
                <div className='price-plan-features-icon'> <FaCircleCheck /></div>
                <div className='price-plan-features-text'>Email Open & Clicking Rating
</div>
              </div>
               <div className='price-plan-features-list'>
                <div className='price-plan-features-icon'> <FaCircleCheck /></div>
                <div className='price-plan-features-text'>Pre - Built Advanced dashboard</div>
              </div>
               <div className='price-plan-features-list'>
                <div className='price-plan-features-icon'> <FaCircleCheck /></div>
                <div className='price-plan-features-text'>KPI & Goal Tracking</div>
              </div>
               <div className='price-plan-features-list'>
                <div className='price-plan-features-icon'> <FaCircleCheck /></div>
                <div className='price-plan-features-text'>Customizable Reports & Filters
</div>
              </div>
            </div>
             <div className='price-feature-container2' style={{height:"500px"}}>
              <div className='price-feature-img2'>
    <img src={campaignpink} alt="robo white" className="streamline stream-pink" />
    <img src={campaignwhite} alt="robo pink" className="streamline stream-white" />
  </div>
              <div className='price-plan-agent'>Campaigns & Engagement</div>
               <div className='price-plan-features-list'>
                <div className='price-plan-features-icon'> <FaCircleCheck /></div>
                <div className='price-plan-features-text'>Unlimited Email Campaigns
</div>
              </div>
               <div className='price-plan-features-list'>
                <div className='price-plan-features-icon'> <FaCircleCheck /></div>
                <div className='price-plan-features-text'>Smart Scheduling & Delivery Tracking</div>
              </div>
               <div className='price-plan-features-list'>
                <div className='price-plan-features-icon'> <FaCircleCheck /></div>
                <div className='price-plan-features-text'>AI Email Composer & Personalization</div>
              </div>
               <div className='price-plan-features-list'>
                <div className='price-plan-features-icon'> <FaCircleCheck /></div>
                <div className='price-plan-features-text'>CRM Integration on Demand
</div>
              </div>
              <div className='price-plan-features-list'>
                <div className='price-plan-features-icon'> <FaCircleCheck /></div>
                <div className='price-plan-features-text'>AI Prompting Assistance for Outreach
</div>
              </div>
              <div className='price-plan-features-list'>
                <div className='price-plan-features-icon'> <FaCircleCheck /></div>
                <div className='price-plan-features-text'>Multi - Step Sequences (email + tasks)
</div>
              </div>
            </div>
             <div className='price-feature-container3' style={{height:"500px"}}>
              <div className='price-feature-img3'>
    <img src={successpink} alt=" white" className="integration inte-pink" />
    <img src={successwhite} alt="robo pink" className="integration inte-white" />
  </div>
              <div className='price-plan-agent'>Support & Success</div>
               <div className='price-plan-features-list'>
                <div className='price-plan-features-icon'> <FaCircleCheck /></div>
                <div className='price-plan-features-text'>SLA - backed Priority Email Support</div>
              </div>
               <div className='price-plan-features-list'>
                <div className='price-plan-features-icon'> <FaCircleCheck /></div>
                <div className='price-plan-features-text'>Dedicated account manager</div>
              </div>
               <div className='price-plan-features-list'>
                <div className='price-plan-features-icon'> <FaCircleCheck /></div>
                <div className='price-plan-features-text'>Onboarding Guidance with Revenuintel Specialist</div>
              </div>
              
            </div>
           </div>
         <div className='lead-generating' style={{marginTop:"70px"}}>
                      <span className="lead-text">Start generating B2B leads today!</span>
                      <button className="demo-btn-talk" onClick={() => {navigate("/free-trial"); window.scrollTo(0, 0); }}>Free Trial  <span className="btn-icon"><BiRightArrowAlt /> </span></button>
                     </div>
                    
                     <div className='landing-6'>
                      <BiSolidQuoteAltLeft style={{marginLeft:"20%",marginTop:"40px"}} />
                     <div className='content-9'>
                     Good Insights for IT startups that serves the best for our Inside Sales team.
                     <br /> I 'would love to recommend to my clients &nbsp; <BiSolidQuoteAltRight style={{fontSize:"15px"}}/>  </div> 
                    
                      <div style={{marginLeft:"100px", marginTop:"10px", color:"black", fontWeight:"700", textAlign:"center", fontSize:"12px"}} >
                       <img src={maskphoto2} alt="maskphoto"  width="50px"/> <br />Erhan Eren <div style={{fontWeight:"500"}}>Founder and CEO, Enkiai.com</div></div>  
                    
       
                     </div>
                 <div className="curved-footer-wrapper">
         <div className="footer-image-container">
           <img src={curve} alt="curve" className="footer-curve-img" />
           <div className="landing-7">
             <div className="land-contents-10">
               We’d love to hear from you <br />
               <span className="land-content-11" style={{marginTop:"20px"}}>support@revenuintel.com</span><br />
              
             </div>
             <div className="land-contents-11">
               Get Revenuintel Today <br />
               <div style={{ position: "relative", display: "flex", alignItems: "center", marginTop: "40px" }}>
         <input type="email" placeholder='Business mail' className='mail-input' value={email}
        onChange={(e) => setEmail(e.target.value)}/>
         <button className="mail-price-btn" onClick={handlePricingClick}>Pricing</button>
       </div>
       
               
             </div>
             <div className="land-contents-13" style={{fontWeight:"500"}}>
               Powered by, <br />
               Merkat Intellekt Technologies <br />
               <span className="land-content-15">Private Limited</span>
             </div>
           </div>
         </div>
       </div>
       
        </div>
         {showBanner && (
                                                          <div className='cookies'>
                                                             <div className='cookie-text'>This website uses cookies to improve your experience. We'll assume you're ok with this, but you can opt-out if you wish</div>
                                                          <div className='cookie' style={{cursor:"pointer"}} onClick={cookiePopup}>Cookie Settings</div>
                                                          <div> <button className="cookie-btn" onClick={handleAccept}>Accept</button></div>
                                                          </div> )}
                                                    {showpopup && (
                                     <div className="overlay">
                                       <div className="privacy-popup">
                                         <div className="privacy-overview">
                                           <div className="popup-header">Privacy Overview</div>
                                           <div className='privacy-close' onClick={handleClose}><IoIosClose /></div>
                                         </div>
                                        <div className="privacy-content">
                                         {isExpanded ? content : `${content.substring(0, 200)}...`}
                                         <span
                                           className="privacy-content-span"
                                           onClick={toggleReadMore}
                                           style={{ color: "blue", cursor: "pointer", marginLeft: "5px" }}
                                         >
                                           {isExpanded ? " See Less" : " See More"}
                                         </span>
                                       </div>
                                      <div className="privacy-neccessary">
                                         <div className="neccessary-head" >
                                           <div className="neccessary-text" onClick={toggleContent}>
                                             <RiArrowDropDownLine
                                               style={{
                                                 fontSize: "35px",
                                                 transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
                                                 transition: "transform 0.3s ease"
                                               }}
                                             />{" "}
                                             Necessary
                                           </div>
                                           <div className="neccessary-text">Always Enabled</div>
                                         </div>
                                   
                                         {isOpen && (
                                           <div className="neccessary-content">
                                             Necessary cookies are absolutely essential for the website to
                                             function properly. This category only includes cookies that ensure
                                             basic functionalities and security features of the website. These
                                             cookies do not store any personal information.
                                           </div>
                                         )}
                                       </div>
                                        <div className="privacy-neccessary">
                                         <div className="neccessary-head" >
                                           <div className="neccessary-text" onClick={toggleContent2}>
                                             <RiArrowDropDownLine
                                               style={{
                                                 fontSize: "35px",
                                                 transform: isOpen2 ? "rotate(180deg)" : "rotate(0deg)",
                                                 transition: "transform 0.3s ease"
                                               }}
                                             />{" "}
                                            Non-Necessary
                                           </div>
                                           <div> <CustomSwitch checked={nonNecessaryEnabled}
                                                 onChange={(e) => setNonNecessaryEnabled(e.target.checked)} /></div>
                                         </div>
                                   
                                         {isOpen2 && (
                                           <div className="neccessary-content">
                                            Any cookies that may not be particularly necessary for the website to function
                                             and is used specifically to collect user personal data via analytics, ads, other embedded 
                                             contents are termed as non-necessary cookies. It is mandatory to procure user consent prior
                                              to running these cookies on your website.
                                           </div>
                                         )}
                                       </div>
                                       <div className='privacy-save'>
                                         <button className='privacy-save-btn' onClick={handleSaveExit}>Save & Exit</button>
                                       </div>
                                       </div>
                                     </div>
                                   )}
    </>
  )
}

export default Pricing;